import audioCompanionTtsScripts from "./audioCompanionTtsScripts.json";
import type { VideoCompanionVideoId } from "./videoCompanionDemo";

interface CompanionFeedbackAudioAsset {
  audioSrc: string;
  spokenText: string;
}

type CompanionFeedbackAudioId =
  | "audioSelectFirst"
  | "audioExpandPreview"
  | "audioBusy"
  | "audioGenerationStart"
  | "videoReset"
  | "videoSelectFirst"
  | "videoQuicklook"
  | "videoContinue"
  | "videoActorFallback";

const companionFeedback = audioCompanionTtsScripts.companionFeedback as Record<
  CompanionFeedbackAudioId,
  CompanionFeedbackAudioAsset
>;

const videoActorFeedback = audioCompanionTtsScripts.videoActorFeedback as Record<
  VideoCompanionVideoId,
  CompanionFeedbackAudioAsset
>;

export function getCompanionFeedbackAudio(id: CompanionFeedbackAudioId) {
  return companionFeedback[id];
}

export function getVideoActorFeedbackAudio(videoId: VideoCompanionVideoId) {
  return videoActorFeedback[videoId] ?? companionFeedback.videoActorFallback;
}
